import { render, staticRenderFns } from "./FontsPanel.vue?vue&type=template&id=9338bb92&scoped=true&"
import script from "./FontsPanel.vue?vue&type=script&lang=js&"
export * from "./FontsPanel.vue?vue&type=script&lang=js&"
import style0 from "./FontsPanel.vue?vue&type=style&index=0&id=9338bb92&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "9338bb92",
  null
  
)

export default component.exports